import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classNames from 'classnames';
import moment from 'moment';
import { Button } from 'primereact/button';

import './style.css';
import trataLinks from '../../modulos/function/trataLinkAceite';

const LogAceites = props => {
    const { data } = props;

    const [isDadosAceite, setDadosAceite] = useState(false);

    const dados = async () => {
        const resultado = await trataLinks(data);

        setDadosAceite(resultado);
    };

    const styles = {
        botaoFechar: {
            width: '50%',
            margin: '0 auto'
        }
    };

    useEffect(() => {
        dados();
    }, [data]);

    function statusBodyTemplate(rowData) {
        const statusClassName = classNames({
            outofstock: rowData.StatusLink === 1,
            lowstock: rowData.StatusLink === 2,
            instock: rowData.StatusLink === 3
        });

        return (
            <div>
                <div className={statusClassName}>{rowData.StatusLink}</div>
            </div>
        );
    }

    function dataBodyTemplate(rowData) {
        return moment(rowData.CreateAt).add(3, 'hours').format('DD/MM/YYYY hh:mm:ss');
    }

    function dataAceiteBodyTemplate(rowData) {
        if (rowData.UpdateAt) {
            return moment(rowData.UpdateAt)
                .add(3, 'hours')
                .format('DD/MM/YYYY hh:mm:ss');
        }

        return '';
    }

    const footer = fecharModal => (
        <div className="p-col p-col-align-center" style={styles.botaoFechar}>
            <Button label="Fechar" onClick={fecharModal} />
        </div>
    );

    return (
        <div>
            <Popup
                modal
                trigger={
                    <button
                        type="submit"
                        icon="pi pi-plus"
                        className="btn-info"
                    >
                        Log Aceite
                    </button>
                }
            >
                {close => (
                    <>
                        <div>
                            {/* <Dialog style={{ width: '40vw' }} visible={close}> */}
                            <div className="p-col-12 p-md-12">
                                <h1 style={{ textAlign: 'center' }}>
                                    Aceites Enviados
                                </h1>
                            </div>
                            {isDadosAceite && (
                                <div className="datatable-responsive-demo">
                                    <DataTable
                                        paginator
                                        rows={8}
                                        emptyMessage="Nenhum resultado encontrado"
                                        currentPageReportTemplate="Mostrando {first} de {last} em {totalRecords}  Registros encontrados"
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        rowsPerPageOptions={[8, 25, 50]}
                                        value={isDadosAceite}
                                        className="p-datatable-responsive-demo"
                                        footer={footer(close)}
                                    >
                                        <Column field="Inscricao" header="Inscrição" />
                                        <Column
                                            field="CreateAt"
                                            body={dataBodyTemplate}
                                            header="Data Envio"
                                        />
                                        <Column
                                            field="TipoAceite"
                                            header="Tipo de Aceite"
                                        />
                                        <Column
                                            field="FormaEnvio"
                                            header="Forma De Envio"
                                        />
                                        <Column
                                            field="UpdateAt"
                                            body={dataAceiteBodyTemplate}
                                            header="Data Aceite"
                                        />
                                        <Column
                                            field="StatusLink"
                                            body={statusBodyTemplate}
                                            header="Status"
                                        />
                                        <Column
                                            field="Destinatario"
                                            header="Enviado para:"
                                        />
                                    </DataTable>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </Popup>
        </div>
    );
};

export default LogAceites;
